import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { detailsModalAssignmentStore } from '../../../model/detailsModalAssignmentStore'
import { studentsStore } from '../../../../../../Students/model/studentsStore'
import { useIsMobile } from 'shared/hooks/useBreakpoint'
import { navigateToStudentProfile } from 'pages/Dashboard/components/TodaysPrioritySection/utils/priorityCardUi'

const formatStudentGradeLabel = raw => {
	if (raw == null || raw === '') return null

	if (typeof raw === 'number' && Number.isFinite(raw)) {
		return `Grade ${Math.trunc(raw)}`
	}

	const str = String(raw).trim().replace(/\s+/g, ' ')
	if (!str) return null

	if (/^\d+$/.test(str)) {
		return `Grade ${str}`
	}

	const leading = /^grade\s*(\d+)/i.exec(str)
	if (leading) {
		return `Grade ${leading[1]}`
	}

	const trailing = /^(\d+)\s*grade$/i.exec(str)
	if (trailing) {
		return `Grade ${trailing[1]}`
	}

	const embedded = /\bgrade\s*(\d+)\b/i.exec(str)
	if (embedded) {
		return `Grade ${embedded[1]}`
	}

	if (/\bgrade\b/i.test(str)) {
		return str.replace(/^grade\b/i, 'Grade')
	}

	return `Grade ${str}`
}

export default function useStudentAccordion({
	student,
	isOpen: controlledIsOpen,
	onToggle,
}) {
	const navigate = useNavigate()
	const [isInternalOpen, setInternalOpen] = useState(controlledIsOpen || false)
	const isMobile = useIsMobile()

	const isOpen =
		controlledIsOpen !== undefined ? controlledIsOpen : isInternalOpen

	useEffect(() => {
		if (controlledIsOpen !== undefined) {
			setInternalOpen(controlledIsOpen)
		}
	}, [controlledIsOpen])

	// Try to get grade from student object first, then from store
	const gradeFromStudent = student?.grade
	const fullStudentData = gradeFromStudent
		? null
		: studentsStore.getStudentById(student.id)
	const gradeFromStore = fullStudentData?.grade

	const studentGrade = formatStudentGradeLabel(
		gradeFromStudent ?? gradeFromStore ?? null,
	)

	const handleToggle = () => {
		if (onToggle) {
			onToggle()
		} else {
			setInternalOpen(!isInternalOpen)
		}
	}

	const handleCheckboxToggle = e => {
		e.stopPropagation()
		detailsModalAssignmentStore.toggleStudentSelection(student.id)
	}

	const handleViewProfile = () => {
		navigateToStudentProfile(navigate, student.id)
	}

	const isSelected = detailsModalAssignmentStore.isStudentSelected(student.id)
	const studentStatus =
		student.status === 'completed'
			? 'completed'
			: student.status === 'in_progress'
				? 'in_progress'
				: 'not_started'
	const statusText =
		studentStatus === 'completed'
			? 'Completed'
			: studentStatus === 'in_progress'
				? 'In Progress'
				: 'Not Started'

	return {
		isOpen,
		studentGrade,
		handleToggle,
		handleCheckboxToggle,
		handleViewProfile,
		isSelected,
		studentStatus,
		statusText,
		isMobile,
	}
}
